import TaskAltIcon from "@mui/icons-material/TaskAlt";

function PointCreateBadgeImageSelection({ selected, setSelected, badges }) {
  return (
    <div className="w-full flex flex-col my-4">
      <span className="mb-2 text-[#6D7C94] text-sm">Select badge icon</span>
      <div className="w-full flex flex-wrap gap-4 bg-gray-50 rounded-md p-4">
        {badges.map((badge, index) => {
          const isSelected = selected === badge.code;
          return (
            <button
              className={
                "w-24 h-24 rounded-md border bg-gray-200 flex items-center justify-center relative" +
                (isSelected ? " bg-[#C4E9E3] border-[#016726]" : "")
              }
              key={index}
              onClick={() => setSelected(badge.code)}
            >
              <div className="absolute left-2 top-2">
                {isSelected ? (
                  <TaskAltIcon className="text-[#016726] text-2xl" />
                ) : (
                  <div className="bg-[#DBDBDB] h-5 w-5 rounded-full"></div>
                )}
              </div>
              <img
                src={badge.active}
                alt=""
                className="w-16 h-16 object-contain"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default PointCreateBadgeImageSelection;
